import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingWhatsApp from '../../components/feature/FloatingWhatsApp';
import { WHATSAPP_URL } from '../../constants/whatsapp';
import { getOrganizationSchema, getWebPageSchema, SCHEMA_SITE_URL } from '@/constants/schema';

const SITE_URL = import.meta.env.VITE_SITE_URL as string;

const PAGE_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    getOrganizationSchema(),
    getWebPageSchema({
      path: '/medical-gloves',
      name: 'Medical Gloves Wholesale Oman | Surgical & Examination Gloves | omandisposables.com',
      description: 'Wholesale surgical, examination & sterile medical gloves for hospitals and clinics in Oman & GCC. Trusted supply.',
      breadcrumbId: `${SCHEMA_SITE_URL}/medical-gloves#breadcrumb`,
    }),
    {
      '@type': 'BreadcrumbList',
      '@id': `${SCHEMA_SITE_URL}/medical-gloves#breadcrumb`,
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Medical Gloves', item: `${SITE_URL}/medical-gloves` },
      ],
    },
    {
      '@type': 'Product',
      '@id': `${SCHEMA_SITE_URL}/medical-gloves#product`,
      'name': 'Medical Gloves Wholesale Oman — Surgical & Examination',
      'description': 'Wholesale surgical, examination and sterile medical gloves for hospitals and clinics in Oman and GCC. Nitrile, latex and sterile latex-free options. Est. 1996.',
      'image': 'https://public.readdy.ai/ai/img_res/32d5ddd7e3d9540fa5335c4402ef5901.jpg',
      'brand': { '@type': 'Brand', 'name': 'Oman Disposables' },
      'category': 'Medical Gloves',
      'url': `${SCHEMA_SITE_URL}/medical-gloves`,
      'offers': {
        '@type': 'Offer',
        'priceCurrency': 'OMR',
        'availability': 'https://schema.org/InStock',
        'areaServed': ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'],
        'seller': { '@type': 'Organization', 'name': 'Oman Disposables' },
      },
    },
    {
      '@type': 'ItemList',
      name: 'Medical Gloves Range — omandisposables.com',
      description: 'Wholesale surgical, examination and sterile medical gloves for hospitals and clinics in Oman and GCC.',
      url: `${SITE_URL}/medical-gloves`,
      numberOfItems: 4,
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'Product',
            name: 'Surgical Gloves',
            description: 'Sterile, powdered or powder-free surgical gloves for operating rooms and sterile procedures.',
            image: 'https://readdy.ai/api/search-image?query=sterile%20packaged%20surgical%20gloves%20in%20white%20clinical%20setting%2C%20medical%20grade%20latex%20surgical%20gloves%20in%20sterile%20pouch%20packaging%2C%20clean%20hospital%20environment%2C%20professional%20product%20photography&width=600&height=420&seq=med-surgical-01&orientation=landscape',
            url: `${SITE_URL}/medical-gloves`,
            category: 'Medical Gloves',
            brand: { '@type': 'Brand', name: 'omandisposables.com' },
            offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: 'omandisposables.com' }, availability: 'https://schema.org/InStock', priceCurrency: 'OMR', areaServed: ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'] },
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'Product',
            name: 'Examination Gloves',
            description: 'Nitrile and latex examination gloves for medical examinations, patient care and diagnostic use.',
            image: 'https://readdy.ai/api/search-image?query=blue%20nitrile%20examination%20gloves%20stack%20on%20white%20medical%20surface%2C%20disposable%20gloves%20for%20hospital%20use%2C%20clinical%20product%20photography%20with%20soft%20lighting&width=600&height=420&seq=med-exam-01&orientation=landscape',
            url: `${SITE_URL}/medical-gloves`,
            category: 'Medical Gloves',
            brand: { '@type': 'Brand', name: 'omandisposables.com' },
            offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: 'omandisposables.com' }, availability: 'https://schema.org/InStock', priceCurrency: 'OMR', areaServed: ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'] },
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'Product',
            name: 'Sterile Latex-Free Gloves',
            description: 'Full nitrile sterile gloves for patients and staff with latex allergies.',
            image: 'https://public.readdy.ai/ai/img_res/edited_a174ade7c17686460347a64aa6c985f9_89ab3684.jpg',
            url: `${SITE_URL}/medical-gloves`,
            category: 'Medical Gloves',
            brand: { '@type': 'Brand', name: 'omandisposables.com' },
            offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: 'omandisposables.com' }, availability: 'https://schema.org/InStock', priceCurrency: 'OMR', areaServed: ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'] },
          },
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'Product',
            name: 'Clinic Examination Packs',
            description: 'Bulk examination glove packs for clinics, GP practices and outpatient departments.',
            image: 'https://readdy.ai/api/search-image?query=boxes%20of%20medical%20examination%20gloves%20stacked%20in%20clinical%20storage%20room%2C%20bulk%20medical%20supply%20storage%2C%20organized%20healthcare%20inventory%20on%20shelves&width=600&height=420&seq=med-clinic-01&orientation=landscape',
            url: `${SITE_URL}/medical-gloves`,
            category: 'Medical Gloves',
            brand: { '@type': 'Brand', name: 'omandisposables.com' },
            offers: { '@type': 'Offer', seller: { '@type': 'Organization', name: 'omandisposables.com' }, availability: 'https://schema.org/InStock', priceCurrency: 'OMR', areaServed: ['OM', 'AE', 'SA', 'KW', 'BH', 'QA'] },
          },
        },
      ],
    },
  ],
};

const PRODUCTS = [
  {
    name: 'Surgical Gloves',
    nameAr: 'قفازات جراحية',
    desc: 'Sterile, powdered or powder-free surgical gloves for operating rooms and sterile procedures.',
    descAr: 'قفازات جراحية معقمة، مع بودرة أو بدون، للغرف الجراحية والإجراءات المعقمة.',
    specs: ['Sterile', 'Latex or Nitrile', 'Various Sizes 5.5–9', 'Paired Packaging'],
    img: 'https://readdy.ai/api/search-image?query=sterile%20packaged%20surgical%20gloves%20in%20white%20clinical%20setting%2C%20medical%20grade%20latex%20surgical%20gloves%20in%20sterile%20pouch%20packaging%2C%20clean%20hospital%20environment%2C%20professional%20product%20photography&width=600&height=420&seq=med-surgical-01&orientation=landscape',
    tag: 'Sterile Grade',
  },
  {
    name: 'Examination Gloves',
    nameAr: 'قفازات الفحص',
    desc: 'Nitrile and latex examination gloves for medical examinations, patient care and diagnostic use.',
    descAr: 'قفازات فحص نيتريل ولاتكس للفحوصات الطبية ورعاية المرضى والاستخدامات التشخيصية.',
    specs: ['Powder-Free', 'Nitrile or Latex', 'Box of 100 pcs', 'XS to XL sizes'],
    img: 'https://readdy.ai/api/search-image?query=blue%20nitrile%20examination%20gloves%20stack%20on%20white%20medical%20surface%2C%20disposable%20gloves%20for%20hospital%20use%2C%20clinical%20product%20photography%20with%20soft%20lighting&width=600&height=420&seq=med-exam-01&orientation=landscape',
    tag: 'Medical Grade',
  },
  {
    name: 'Sterile Latex-Free Gloves',
    nameAr: 'قفازات معقمة خالية من اللاتكس',
    desc: 'For patients and staff with latex allergies. Full nitrile sterile gloves with precision fit.',
    descAr: 'للمرضى والطاقم الطبي الحساسين من اللاتكس. قفازات نيتريل معقمة ذات ملاءمة دقيقة.',
    specs: ['100% Latex-Free', 'Sterile Packaged', 'Hypoallergenic', 'High Tactile Sensitivity'],
    img: 'https://public.readdy.ai/ai/img_res/edited_a174ade7c17686460347a64aa6c985f9_89ab3684.jpg',
    tag: 'Hypoallergenic',
  },
  {
    name: 'Clinic Examination Packs',
    nameAr: 'عبوات فحص العيادات',
    desc: 'Bulk examination glove packs for clinics, GP practices and outpatient departments.',
    descAr: 'عبوات قفازات فحص بالجملة للعيادات والممارسات العامة وأقسام العيادات الخارجية.',
    specs: ['10 boxes per case', 'Mixed size packs available', 'Fast delivery', 'Trusted Supply'],
    img: 'https://readdy.ai/api/search-image?query=boxes%20of%20medical%20examination%20gloves%20stacked%20in%20clinical%20storage%20room%2C%20bulk%20medical%20supply%20storage%2C%20organized%20healthcare%20inventory%20on%20shelves&width=600&height=420&seq=med-clinic-01&orientation=landscape',
    tag: 'Bulk Packs',
  },
];

const SPECS_FEATURES = [
  { icon: 'ri-award-line', en: 'Sterile Grade Available', ar: 'متوفر بدرجة معقمة' },
  { icon: 'ri-heart-pulse-line', en: 'Medical Grade Quality', ar: 'جودة المعدات الطبية' },
  { icon: 'ri-drop-line', en: 'Latex-Free Options', ar: 'خيارات خالية من اللاتكس' },
  { icon: 'ri-hand-sanitizer-line', en: 'Powder-Free Available', ar: 'خيارات بدون بودرة' },
  { icon: 'ri-truck-line', en: 'Bulk Orders Ready', ar: 'جاهز للطلبات الكبيرة' },
];

export default function MedicalGlovesPage() {
  return (
    <main>
      <title>Medical Gloves Wholesale Oman | Surgical & Examination Gloves | omandisposables.com</title>
      <meta name="description" content="Wholesale surgical, examination & sterile medical gloves for hospitals and clinics in Oman & GCC. Trusted supply. WhatsApp for bulk pricing." />
      <meta name="keywords" content="medical gloves Oman, surgical gloves wholesale, examination gloves Muscat, nitrile medical gloves GCC, sterile gloves supplier" />
      <link rel="canonical" href={`${SITE_URL}/medical-gloves`} />
      <meta property="og:title" content="Medical Gloves Wholesale Oman | omandisposables.com" />
      <meta property="og:description" content="Wholesale surgical, examination & sterile medical gloves for hospitals and clinics in Oman & GCC. Trusted supply." />
      <meta property="og:url" content={`${SITE_URL}/medical-gloves`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=medical%20professional%20in%20hospital%20wearing%20blue%20nitrile%20gloves%20examining%20patient%2C%20clean%20clinical%20environment%2C%20bright%20overhead%20lighting%2C%20professional%20healthcare%20photography&width=1200&height=630&seq=med-hero-og&orientation=landscape" />
      <meta property="og:site_name" content="omandisposables.com" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Medical Gloves Wholesale Oman | omandisposables.com" />
      <meta name="twitter:description" content="Wholesale surgical, examination & sterile medical gloves for hospitals in Oman & GCC. Trusted supply." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=medical%20professional%20in%20hospital%20wearing%20blue%20nitrile%20gloves%20examining%20patient%2C%20clean%20clinical%20environment%2C%20bright%20overhead%20lighting%2C%20professional%20healthcare%20photography&width=1200&height=630&seq=med-hero-og&orientation=landscape" />
      <meta name="twitter:site" content="@omandisposables" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(PAGE_SCHEMA) }}
      />

      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-16 bg-navy overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=medical%20professional%20in%20hospital%20wearing%20blue%20nitrile%20gloves%20examining%20patient%2C%20clean%20clinical%20environment%2C%20bright%20overhead%20lighting%2C%20professional%20healthcare%20photography&width=1920&height=600&seq=med-hero-01&orientation=landscape"
            alt="Medical Gloves Wholesale Oman - omandisposables.com"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-navy/90 to-navy/60" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
          <div className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/40 text-brand-green text-sm font-semibold px-4 py-2 rounded-full mb-6">
            🏅 Trusted Medical Gloves Supplier from Oman
          </div>
          <h1 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl mb-3">
            Medical Gloves Wholesale
          </h1>
          <p className="font-arabic text-white/80 text-2xl md:text-3xl font-bold mb-4" dir="rtl">
            القفازات الطبية بالجملة
          </p>
          <p className="text-white/90 text-base md:text-lg max-w-2xl mb-8">
            Surgical, examination &amp; sterile gloves for hospitals, clinics and healthcare facilities
            across Oman and GCC.
          </p>
          <p className="font-arabic text-white/80 text-base max-w-2xl mb-8 text-right" dir="rtl">
            قفازات جراحية وفحص ومعقمة للمستشفيات والعيادات ومرافق الرعاية الصحية في عُمان والخليج.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp text-base px-8 py-4 rounded-full shadow-xl hover:scale-105 transition-transform inline-flex"
          >
            <i className="ri-whatsapp-line text-xl" />
            💬 WhatsApp for Medical Gloves Pricing
          </a>
        </div>
      </section>

      {/* Trust bar */}
      <div className="bg-brand-green py-3 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-6 text-white text-sm font-semibold">
          {['Sterile Grade', 'Medical Grade', 'Latex-Free Options', 'Bulk Ready'].map((t) => (
            <span key={t} className="flex items-center gap-1">
              <i className="ri-checkbox-circle-fill" />{t}
            </span>
          ))}
        </div>
      </div>

      {/* Products */}
      <section className="section-padding bg-white">
        <div className="container-max">
          <div className="text-center mb-12">
            <h2 className="section-title-en text-3xl md:text-4xl mb-2">Our Medical Glove Range</h2>
            <p className="section-title-ar text-2xl md:text-3xl" dir="rtl">مجموعة القفازات الطبية لدينا</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-product-shop>
            {PRODUCTS.map((p) => (
              <div key={p.name} className="bg-white border border-gray-100 rounded-xl overflow-hidden hover:border-brand-green/30 hover:shadow-md transition-all">
                <div className="w-full h-52 overflow-hidden">
                  <img src={p.img} alt={`${p.name} - omandisposables.com Oman`} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-5">
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <div>
                      <h3 className="font-heading font-bold text-navy text-lg">{p.name}</h3>
                      <p className="font-arabic text-gray-500 text-sm" dir="rtl">{p.nameAr}</p>
                    </div>
                    <span className="shrink-0 bg-brand-green/10 text-brand-green text-xs font-semibold px-3 py-1 rounded-full">{p.tag}</span>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-2">{p.desc}</p>
                  <p className="font-arabic text-gray-500 text-xs text-right mb-4 leading-relaxed" dir="rtl">{p.descAr}</p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {p.specs.map((s) => (
                      <span key={s} className="text-xs bg-gray-50 border border-gray-200 text-gray-600 px-2.5 py-1 rounded-full">{s}</span>
                    ))}
                  </div>
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-whatsapp text-sm px-4 py-2.5 rounded-full w-full justify-center"
                  >
                    <i className="ri-whatsapp-line" />
                    Get Price &amp; Availability
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specs */}
      <section className="section-padding bg-gray-50">
        <div className="container-max">
          <div className="text-center mb-10">
            <h2 className="section-title-en text-2xl md:text-3xl mb-2">Quality &amp; Standards</h2>
            <p className="section-title-ar text-xl md:text-2xl" dir="rtl">الجودة والمعايير</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {SPECS_FEATURES.map((f) => (
              <div key={f.en} className="flex flex-col items-center text-center p-5 bg-white rounded-xl border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-navy/5 mb-3">
                  <i className={`${f.icon} text-2xl text-navy`} />
                </div>
                <p className="font-heading font-semibold text-navy text-xs">{f.en}</p>
                <p className="font-arabic text-gray-600 text-xs mt-0.5" dir="rtl">{f.ar}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section-padding bg-navy text-center">
        <div className="container-max">
          <div className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/40 text-brand-green text-sm font-semibold px-4 py-2 rounded-full mb-6">
            🏅 جودة موثوقة. راسخون في عُمان. | Quality. Rooted in Oman.
          </div>
          <h2 className="font-heading font-black text-white text-3xl md:text-4xl mb-3">
            Order Medical Gloves Wholesale
          </h2>
          <p className="font-arabic text-white/80 text-xl font-bold mb-6" dir="rtl">
            طلب القفازات الطبية بالجملة
          </p>
          <p className="text-white/85 text-base max-w-lg mx-auto mb-8">
            Get pricing, samples, and bulk quotes directly from our team. 24-hour WhatsApp response guaranteed.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp text-base px-8 py-4 rounded-full shadow-xl hover:scale-105 transition-transform w-full sm:w-auto justify-center"
            >
              <i className="ri-whatsapp-line text-xl" />
              💬 WhatsApp for Wholesale Price
            </a>
            <Link
              to="/request-quote"
              className="bg-white/10 border border-white/20 text-white font-heading font-semibold px-8 py-4 rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto flex items-center justify-center gap-2"
            >
              📋 Request a Quote
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
